import { unzipArrayBuffer, createSessionZip, createSetlistZip, openSessionZip, openSetlistZip } from "../../factories/Zipper";
import audioEngine from "../../services/audioEngine";

import { getAssetItem, getAsset, setAssetItem } from "../../services/assetStore";
import {  specialCaseChannels } from "./sessionSlice";
import { extraStemTitleProcessor, triggerBlobDownload } from "../../factories/ui";

import { getCgAuthHeaders, isCgTestingEnabled } from "../../utils/cgTesting";
import {
  isUgcTestingEnabled,
  fetchRemoteUgcSongById,
  normaliseUgcSong,
} from "../../utils/ugcTesting";


let byteArray = null



// pgw 02-apr-2025
let doprint = false;
// let doprint = true;

// pgw 04-may-2025
// For Choir Genius testing
// let doprintForCG = true;
let doprintForCG = false;

// Function to get Unicode values of a string
function getUnicodeValues(inputString) {
    // Initialize an array to store the Unicode values
    let unicodeValues = [];

    // Loop through each character in the string
    for (let i = 0; i < inputString.length; i++) {
        // Get the Unicode value of the character and add it to the array
        unicodeValues.push(inputString.charCodeAt(i));
    }

    // Return the array of Unicode values
    return unicodeValues;
}

function cacheBustingUrl(url) {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}cb=${Date.now()}`;
}


async function downloadToArrayBuffer(url) {

  const headers = new Headers(
    isCgTestingEnabled()
      ? getCgAuthHeaders()
      : { "x-auth-token": AUTH_TOKEN }
  );

  if (doprint || doprintForCG) {
	console.log("pgw downloadToArrayBuffer Request Headers (fetch will use):");
  	headers.forEach((value, key) => console.log(`${key}: ${value}`));
  }

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
      mode: "cors" // This triggers the OPTIONS preflight automatically
    });

	if (doprint || doprintForCG) {
		console.log("pgw downloadToArrayBufferResponse Headers:");
		for (let [key, value] of response.headers.entries()) {
		  console.log(`${key}: ${value}`);
		}
	}


    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }

    const arrayBuffer = await response.arrayBuffer();
    if (doprint || doprintForCG) console.log(`pgw downloadToArrayBuffer Downloaded ${arrayBuffer.byteLength} bytes`);
    return arrayBuffer;

  } catch (err) {
    console.error("pgw downloadToArrayBuffer Failed to download audio:", err);
	throw new Error(`HTTP error: ${err}`);
  }
}



export const mountSessionInAudioEngine =  async (session, offline = false, onProgress, clientConfig, cache) => {
  


  let updatedSession = {
	...session,
	song: {
	  ...session.song,
	  lyricsUrl: session.song?.lyricsUrl || session.song?.lyrics || "",
	  lyrics: session.song?.lyrics || session.song?.lyricsUrl || "",
	  chapters: Array.isArray(session.song?.chapters) ? session.song.chapters : [],
	},
  };

  if (isUgcTestingEnabled() && updatedSession.song?.songId) {

    if (doprint || doprintForCG) {
		console.log("[UGC] mountSessionInAudioEngine before remote enrich =", {
		  songId: updatedSession.song.songId,
		  chaptersCount: updatedSession.song.chapters?.length || 0,
		  lyricsUrl: updatedSession.song.lyricsUrl,
		  lyrics: updatedSession.song.lyrics,
		});
	}


    const remoteUgcSong = await fetchRemoteUgcSongById(updatedSession.song.songId);

    if (remoteUgcSong) {
      const normalisedRemoteUgcSong = normaliseUgcSong(remoteUgcSong);

      updatedSession = {
        ...updatedSession,
        song: {
          ...updatedSession.song,
          ...normalisedRemoteUgcSong,
          lyricsUrl: normalisedRemoteUgcSong.lyricsUrl || normalisedRemoteUgcSong.lyrics || "",
          lyrics: normalisedRemoteUgcSong.lyrics || normalisedRemoteUgcSong.lyricsUrl || "",
          chapters: Array.isArray(normalisedRemoteUgcSong.chapters)
            ? normalisedRemoteUgcSong.chapters
            : [],
        },
      };
    }

    if (doprint || doprintForCG) {
		console.log("[UGC] mountSessionInAudioEngine after remote enrich =", {
		  songId: updatedSession.song?.songId,
		  mix: updatedSession.song?.mix,
		  chaptersCount: updatedSession.song?.chapters?.length || 0,
		  chapters: updatedSession.song?.chapters,
		  lyrics: updatedSession.song?.lyrics,
		  lyricsUrl: updatedSession.song?.lyricsUrl,
		});
	}
  }

  if (doprint || doprintForCG) {
	  console.log("[UGC] mountSessionInAudioEngine metadata used =", {
		songId: updatedSession.song?.songId,
		mix: updatedSession.song?.mix,
		chaptersCount: updatedSession.song?.chapters?.length || 0,
		chapters: updatedSession.song?.chapters,
		lyrics: updatedSession.song?.lyrics,
		lyricsUrl: updatedSession.song?.lyricsUrl,
	  });
  }


  onProgress({step:1, downloadPercentage:0});




  let encodedAudioBuffers = [];

  // pgw 04-may-2025
  // Add logic to get stem files 

//   if (doprint || doprintForCG) console.log("pgw session.song.pathzip = ", session.song.pathzip); 

  if (session.song.pathzip) {
    if (doprint || doprintForCG) console.log("pgw 1 session.song.pathzip is defined"); 
	if (doprint || doprintForCG) console.log("pgw 2 session.song.pathzip = ", session.song.pathzip);
  }
  else {
    if (doprint || doprintForCG) console.log("pgw 3 session.song.pathzip NOT defined"); 
  }



  if (session.song.pathzip) {


    if (doprint || doprintForCG) console.log("pgw 4 session.song.pathzip is defined"); 

	// pgw 18-sep-2024 add random query string as cache-buster
	if (doprint || doprintForCG) console.log("pgw session.song.pathzip = ", session.song.pathzip);
	const uniqueEndpoint = cacheBustingUrl(session.song.pathzip)
	if (doprint || doprintForCG) console.log("pgw uniqueEndpoint = ", uniqueEndpoint); 

	// pgw 03-apr-2025 - testing remove uniqueEndpoint
    // let sessionSongZipFileResponse = await getAsset(uniqueEndpoint, cache, (downloadPercentage) => onProgress({step:1, downloadPercentage})); // needs to fetch from cache if available, otherwise fetch remotely, throw error if it fails to download (no internet connection)
    let sessionSongZipFileResponse = await getAsset(session.song.pathzip, cache, (downloadPercentage) => onProgress({step:1, downloadPercentage})); // needs to fetch from cache if available, otherwise fetch remotely, throw error if it fails to download (no internet connection)

    let unzippedSongObject = await unzipArrayBuffer(
      sessionSongZipFileResponse,
      (index, pro) => {}
    );
    onProgress({step:2, downloadPercentage:100});
  
    const audioAssetFilenames = Object.getOwnPropertyNames(unzippedSongObject);

	// pgw 22-jul-2024
	// console.log("audioAssetFilenames = ", audioAssetFilenames);
    if (doprint || doprintForCG) console.log("pgw audioAssetFilenames = ", audioAssetFilenames); 
    if (doprint || doprintForCG) console.log("pgw updatedSession.song.tracks = ", updatedSession.song.tracks); 

    // check number of tracks matches audioAssestFilenames length
    if (updatedSession.song.tracks.length !== audioAssetFilenames.length) throw new Error('Zip contains a different amount of stems to the number of stems defined in the song JSON');
  
    for (let index = 0; index < updatedSession.song.tracks.length; index++) {
      const trackName = `${updatedSession.song.tracks[index].name.replace(' ', '_')}`;
      if (doprint || doprintForCG) console.log("pgw index = ", index); 
      if (doprint || doprintForCG) console.log("pgw trackName = ", trackName); 
      encodedAudioBuffers[index] = await unzippedSongObject[trackName].arrayBuffer();
    }

    if (doprint || doprintForCG) console.log("pgw updatedSession = ", updatedSession); 

  }
  else {

    if (doprint || doprintForCG) console.log("pgw 5 session.song.pathzipis NOT  defined"); 

	try {
		// pgw 04-may-2025
		// pathzip is missing: try to get individual files
		if (doprint || doprintForCG) console.log("pgw updatedSession.song.tracks = ", updatedSession.song.tracks); 
    	if (doprint || doprintForCG) console.log("pgw updatedSession = ", updatedSession); 


		for (let index = 0; index < updatedSession.song.tracks.length; index++) {
		  const trackName = updatedSession.song.tracks[index].name;
		  if (doprint || doprintForCG) console.log("pgw index = ", index); 
		  if (doprint || doprintForCG) console.log("pgw trackName = ", trackName); 

		  if (false) {
			  byteArray = await downloadToArrayBuffer(trackName);
			  encodedAudioBuffers[index] = byteArray;
		  }

		  if (true) {
    		  byteArray = await getAsset(trackName, cache, (downloadPercentage) => onProgress({step:1, downloadPercentage}));
			  encodedAudioBuffers[index] = byteArray;

		  }

		}

    	onProgress({step:2, downloadPercentage:100});

	}
	catch(e) {
		if (doprint || doprintForCG) console.log("pgw e = ", e); 
	}

  }

// Function to remove the first character of a string
function removeFirstCharacter(inputString) {
    // Check if the string is not empty
    if (inputString.length > 0) {
        // Return the string without the first character
        return inputString.substring(1);
    }
    // Return the original string if it's empty
    return inputString;
}

function startsWithDecimalPrefix(str) {
  return /^[0-9]{1,2}_/.test(str);
}

  onProgress({step:3, downloadPercentage:100});
  // console.log(audioEngine.processorNode);
  if (!audioEngine.processorNode || offline) {
    await audioEngine.createAudioWorklet(encodedAudioBuffers.length, offline);
  } else {
    await audioEngine.destructProcessorMixerEngine(encodedAudioBuffers.length);
  }

  // load buffers into audio engine
  // audioEngine.loadChannelBuffers.call(audioEngine, decodedAudioBuffers);
  await audioEngine.loadChannelEncodedBuffers.call(audioEngine, encodedAudioBuffers);

  onProgress({step:5, downloadPercentage:100});
    // return status
  
  let populatedStems = [];

	// pgw 22-jul-2024
	// debugging stem label logic
	if (doprint) console.log("pgw updatedSession.song.tracks.length = ", updatedSession.song.tracks.length);

	let numberedStems = false;
	let hasTrackNames = false;

	if (updatedSession.song.tracks.length > 0) {
		if (doprint) console.log("pgw updatedSession.song.tracks[0].name = ", updatedSession.song.tracks[0].name);


		if (updatedSession.song.tracknames && updatedSession.song.tracknames.length == updatedSession.song.tracks.length) {
			if (doprint) console.log("pgw updatedSession.song.tracknames[0].name = ", updatedSession.song.tracknames[0].name);
			hasTrackNames = true;
		}
		else {
			if (startsWithDecimalPrefix(updatedSession.song.tracks[0].name)) {
				numberedStems = true;
			}
		}

	}


	if (doprint) console.log("pgw numberedStems = ", numberedStems);

  for (let index = 0; index < updatedSession.song.tracks.length; index++) {


	  // pgw 22-jul-2024 Remove first character, which allows it to be used to identify the stem

	  const fullTrackName = updatedSession.song.tracks[index].name
	  if (doprint) console.log("pgw fullTrackName = ", fullTrackName);

	  let shortTrackName = fullTrackName;

	  if (hasTrackNames) {
		  shortTrackName = updatedSession.song.tracknames[index].name;
	  }
	  else {
		  if (numberedStems) {
			  shortTrackName = removeFirstCharacter(fullTrackName);
		  }
	  }

	  if (doprint) console.log("pgw shortTrackName = ", shortTrackName);

//       const trackLabel = clientConfig.logic.applyExtraLogicToStemTitles? extraStemTitleProcessor(updatedSession.song.tracks[index].name, updatedSession.song.tracks) : clientConfig.logic.trimStemTitles? updatedSession.song.tracks[index].name.split('_').pop() : updatedSession.song.tracks[index].name
      let trackLabel = "";

	  if (hasTrackNames) {
		trackLabel = shortTrackName;
	  }
	  else {
		trackLabel = clientConfig.logic.applyExtraLogicToStemTitles? extraStemTitleProcessor(numberedStems, shortTrackName, updatedSession.song.tracks) : clientConfig.logic.trimStemTitles? updatedSession.song.tracks[index].name.split('_').pop() : updatedSession.song.tracks[index].name
	  }
		
	  let trackid = trackLabel

	  if (hasTrackNames) {
		  trackid = trackLabel;
	  }
	  else {
		if ((updatedSession.song.tracks.length > 4) && (index == 4)) {
			trackLabel = "BAND";
		}
		if (numberedStems) {
		  trackid = "" + fullTrackName[0] + trackLabel
		}
	  }


      const existingStemObject = updatedSession.stems.find(s => s.index === index);

		// debugging stem label logic
		if (doprint) console.log("pgw index = ", index);
		if (doprint) console.log("pgw trackLabel = ", trackLabel);
		if (doprint) console.log("pgw trackid = ", trackid);
		if (doprint) console.log("pgw existingStemObject = ", existingStemObject);

      const stem = {
        index: index,
        id: trackid,
        label: trackLabel,
        level: existingStemObject ? existingStemObject.level : specialCaseChannels(clientConfig).includes(trackLabel) && !clientConfig.features.session.introChannelNames.includes(trackLabel) ? 0 : clientConfig.features.session.initialStemLevel,
        pan: existingStemObject? existingStemObject.pan : 0.5,
        reverb: existingStemObject ? existingStemObject.reverb : {
          displayValue: "0",
          value: 0,
        },
        muted: existingStemObject ? existingStemObject.muted : false,
        soloed: existingStemObject? existingStemObject.soloed : false,
        isGuideChannel: specialCaseChannels(clientConfig).includes(trackLabel)
      };
      
      populatedStems.push(stem);
      
      
  }
  // console.log(JSON.stringify(populatedStems));
  populatedStems = populatedStems.sort((a,b) => Number(a.isGuideChannel) - Number(b.isGuideChannel));

    // addUserAudio (if any) to channel by pointer
    const populatedUserStems = [];
    for (const userStem of updatedSession.userStems) {
      const updatedUserStem = {...userStem};
      updatedUserStem.armed = false; // mounted sessions alwasys set teh input channels to unarmed
      audioEngine.addInputChannel(updatedUserStem.label, session.song.len + 1, updatedUserStem.id)
      // fetch the audio from the cache

	if (doprint || doprintForCG) console.log('mountSessionInAudioEngine calling getAssetItem userStem.id = ', updatedUserStem.id)

      const fetchedAsset = await getAssetItem(updatedUserStem.id);
      if (fetchedAsset) {
        
        await audioEngine.loadChannelEncodedBuffer(fetchedAsset, updatedUserStem.index)
        
      }
      populatedUserStems.push(updatedUserStem);
    }

    updatedSession.stems = populatedStems;
    updatedSession.userStems = populatedUserStems;
    return {
        ...updatedSession,
        sections: transformSections(updatedSession.song.chapters, updatedSession.song.len)
    }
}

export const unmountSessionInAudioEngine = async () => {
  // unload audio graph, superpowered and session state
  await audioEngine.destroyAudioWorklet();
  await audioEngine.unloadSp();
  await audioEngine.loadSP();
  return true;
}

export const destructProcessorMixerEngine = async (newChannelCount) => {
  // desruct MixerEngine and channel, freeing up memory allocations in the WASM heap.
  await audioEngine.destructProcessorMixerEngine(newChannelCount);
  return true;
}


export const syncAudioEngineChannelSettings = async (session, onProgress) => {
  if (doprint) console.log("[FEATURES_SESSION_SESSIONAPI] syncAudioEngineChannelSettings p1 session = ", session);

  if (!session?.id) return false;
  if (!Array.isArray(session?.stems) || session.stems.length === 0) return false;

  const userStems = Array.isArray(session.userStems) ? session.userStems : [];
  const channelsToSync = (session.stems || []).concat(session.userStems || []);
  const sessionHasASoloedChannel = channelsToSync.find(c => c.soloed); // name says muted but logic is solo

  if (doprint) console.log("[SYNC] about to sync channels", channelsToSync.map(c => ({
	id: c.id,
	index: c.index,
	level: c.level,
	muted: c.muted,
	soloed: c.soloed,
	pan: c.pan
  })));

  for (const channel of channelsToSync) {
    audioEngine.sendChannelParamChange(channel.index, "channelGain", channel.level);
    audioEngine.sendChannelParamChange(
      channel.index,
      "mute",
      sessionHasASoloedChannel ? !channel.soloed : channel.muted
    );
    audioEngine.sendChannelParamChange(channel.index, "pan", channel.pan);
    if (channel.isInputChannel) audioEngine.sendChannelParamChange(channel.index, "arm", channel.armed);
  }

  audioEngine.sendGlobalParamChange("playbackRate", session.speed.value);
  audioEngine.sendGlobalParamChange("pitchShiftCents", session.pitch.value);
  return true;
};


export const resetAudioEngineChannelSettings = async (session, clientConfig) => {
  if (doprint) console.log("[FEATURES_SESSION_SESSIONAPI] resetAudioEngineChannelSettings session = ", session);


if (!session?.id || !session?.stems) {
  if (doprint) console.log("[FEATURES_SESSION_SESSIONAPI] resetAudioEngineChannelSettings - returning because session?.id or session?.stems not defined");
  return;
}


  // Guard: only require the fields you truly need
  if (!session?.id) {
    if (doprint) console.log("[FEATURES_SESSION_SESSIONAPI] resetAudioEngineChannelSettings - returning (no session.id)");
    return;
  }

  if (!Array.isArray(session?.stems) || session.stems.length === 0) {
    if (doprint) console.log("[FEATURES_SESSION_SESSIONAPI] resetAudioEngineChannelSettings - returning (no stems yet)", {
      sessionId: session?.id,
      stems: session?.stems
    });
    return;
  }

  const userStems = Array.isArray(session.userStems) ? session.userStems : [];

  if (doprint) console.log('[FEATURES_SESSION_SESSIONAPI] resetAudioEngineChannelSettings called', {
	sessionId: session?.id,
	speed: session?.speed?.value,
	pitch: session?.pitch?.value,
	stems: session?.stems?.map(s => ({ id: s.id, level: s.level })),
  });

  const excluded = specialCaseChannels(clientConfig);

  const channelsToSync =
	(session.stems || [])
	  .concat(session.userStems || [])
	  .filter(c => c && !specialCaseChannels(clientConfig).includes(c.id));

  if (doprint) console.log("[FEATURES_SESSION_SESSIONAPI] resetAudioEngineChannelSettings channelsToSync", channelsToSync.map(c => ({
    id: c.id, index: c.index
  })));

  for (const channel of channelsToSync) {
    audioEngine.sendChannelParamChange(channel.index, "channelGain", 1);
    audioEngine.sendChannelParamChange(channel.index, "mute", false);
    audioEngine.sendChannelParamChange(channel.index, "pan", 0.5);
    if (channel.isInputChannel) audioEngine.sendChannelParamChange(channel.index, "arm", false);
  }

  audioEngine.sendGlobalParamChange("playbackRate", 1);
  audioEngine.sendGlobalParamChange("pitchShiftCents", 0);
};


export const startAudioEngine = async (offlineRenderingOptions = null) => {
  await audioEngine.loadSP(offlineRenderingOptions);
}

export const renderSession = async (fileName) => {
  await audioEngine.getAudioContextRender(fileName);
};

export const unpackSetlist = async (setlistZipBlob) => {
  let setlistBlobs = await openSetlistZip(
    setlistZipBlob,
    (index, pro) => {}
  );
  return setlistBlobs;
}

export const unpackSession = async (sessionZipBlob) => {

	if (doprint || doprintForCG) console.log("pgw 1 unpackSession"); 


  let unzippedSession = await openSessionZip(
    sessionZipBlob,
    (index, pro) => ()=>{}
  );
  for (const audioAssetName of  Object.getOwnPropertyNames(unzippedSession.audioAssets)) {

	if (doprint || doprintForCG) console.log("pgw 1 unpackSession audioAssetName = ", audioAssetName); 

    await setAssetItem(audioAssetName, unzippedSession.audioAssets[audioAssetName]);
  }
  return unzippedSession.session;
}

export const packSession = async (session) => {
  // Cretae new zip file
  const userAudioObjects = [];

  for (const userStem of session.userStems) {

	if (doprint || doprintForCG) console.log('packSession calling getAssetItem userStem.id = ', userStem.id)

    const fetchedAsset = await getAssetItem(userStem.id);
    if (fetchedAsset) {
      userAudioObjects.push({
        fileName: `${userStem.id}`,
        arrayBuffer: fetchedAsset
      });
    }
  }

  const zipBlob = await createSessionZip(session, userAudioObjects);
  return zipBlob;
}


// pgw 24-apr-2026
/*
export const transformSections = (chapters, duration) => {
  const convertedDuration = Number(duration);
  return chapters.map((chapter, index) => ({
    label: chapter.name,
    start: chapter.time,
    end: chapters[index + 1]?.time || convertedDuration
  }));
}


export const transformSections = (chapters, duration) => {
  if (!Array.isArray(chapters)) {
    return [];
  }

  const convertedDuration = Number(duration) || 0;

  return chapters.map((chapter, index) => ({
    label: chapter.name,
    start: chapter.time,
    end: chapters[index + 1]?.time || convertedDuration
  }));
}
*/

export const transformSections = (chapters, duration) => {
  const convertedDuration = Number(duration) || 0;

  if (!Array.isArray(chapters) || chapters.length === 0) {
    return [
      {
        label: "Start",
        start: 0,
        end: convertedDuration,
      },
    ];
  }

  return chapters.map((chapter, index) => ({
    label: chapter.name || `Section ${index + 1}`,
    start: Number(chapter.time) || 0,
    end: Number(chapters[index + 1]?.time) || convertedDuration,
  }));
};
